/* RESPONSIBLE TEAM: team-rd-services */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorScorecardAttributeValueRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.scorecard.attribute.value',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorScorecardAttributeValueRoute);
